import React from "react";
import { FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import PasswordShow from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-show.svg'

interface Props {
    field: FormSectionElements;
    callback: (programContainer: ProgramContainer) => void
}

export default class PasswordShowButtonCompnent extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

    }

    render() {
        const field = this.props.field;
        return <a onClick={() => { field.mask = false; this.props.callback(field.parent.parent.parent) }}>
            <img
                src={PasswordShow}
                alt=""
                style={{
                    cursor: 'pointer',
                    height: '24px',
                    width: '24px'
                }}
            />
        </a>
    }
}